<template>
  <div>
    <v-layout v-if="adds==1" pa-2 wrap justify-center>
      <v-flex py-2 xs12 sm12 md12 lg10 xl10>
        <v-img src="./../../assets/images/a12.jpg" contain>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout v-if="adds==2" pa-2 wrap justify-center>
      <v-flex py-1 xs12 sm12 md5>
        <v-img src="./../../assets/images/a10.jpg" contain>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
      <v-flex py-1 xs12 sm12 md5>
        <v-img src="./../../assets/images/a11.jpg" contain>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout v-if="adds==3" pa-2 wrap justify-center>
      <v-flex py-2 xs12 sm12 md12 lg10 xl10>
        <v-img src="./../../assets/images/a3.jpg" contain>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["adds"],
  data() {
    return {
      advertisements: 0,
    };
  },
  beforeMount() {},
};
</script>